import BaseService from './BaseService'
export class ManufacturerService extends BaseService {
  // eslint-disable-next-line no-useless-constructor
  constructor (axios) {
    super(axios)
  }
  loadManufacturer (data) {
    const url = 'hy-sb-item/manufacturer/manufacturerList'
    return this.httpTool.get(url, { params: data })
      .then((response) => {
        var manufacturers = []
        const { content = [] } = response
        content.forEach(manufacturerInfo => {
          var tmpManufacturerInfo = this.dealManufacturer(manufacturerInfo)
          manufacturers.push(tmpManufacturerInfo)
        })
        return manufacturers
      })
      .catch(function (error) {
        console.log(error)
        return null
      })
  }
  dealManufacturer (manufacturerInfo) {
    var temManufacturer = {};
    ({ id: temManufacturer.id, name: temManufacturer.name, unionId: temManufacturer.unionId,
      img: temManufacturer.img = require('../../static/images/companyimg.png') } = manufacturerInfo)
    return temManufacturer
  }
}
